export enum TabType {
  // eslint-disable-next-line no-unused-vars
  COMPONENT = 'tab-component',
  // eslint-disable-next-line no-unused-vars
  ADMIN = 'admin',
}
